import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import DataTable from '../../components/Table/DataTable';
import SearchBox from './../../components/SearchBox/SearchBox';

import { showAlert } from '../../store/ducks/alert';
import { CircularProgress } from '@material-ui/core';

import { getWithdrawRequests } from '../../services/payment';

const WithdrawRequests = () => {
  const dispatch = useDispatch();
  const params = useParams();

  const [transactions, setTransactions] = useState([]);
  const [actualPage, setActualPage] = useState(0);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [pageTitle, setPageTitle] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState(null);
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    let page = params.page || actualPage;
    displayWithdrawRequests(page);
  }, []);

  const displayWithdrawRequests = async page => {
    try {
      if (!page) page = actualPage;
      setIsLoading(true);
      const { data } = await getWithdrawRequests(page);
      setTransactions(data.rows);
      setPageTitle('Withdraw Requests');
      setTotalItems(data.count);
      setTotalPages(data.pages);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert('error', error.message));
      console.log(error);
    }
  };

  const headers = ['transactionIdInOrigin', 'toChannelId', 'value', 'paymentType', 'status', 'confirmed', 'currency', 'paymentDate'];
  const searchBoxHeaders = ['toChannelId', 'value', 'paymentType', 'status', 'paymentDate', 'transactionIdInOrigin'];

  const handleSubmitSearch = searchBox => {
    setSearch(searchBox);
    setIsSearching(true);
    displayWithdrawRequests(0, searchBox);
  };

  const handleChangePage = async page => {
    setActualPage(page);
    displayWithdrawRequests(page);
  };

  if (isLoading) return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>
          {pageTitle} ({totalItems})
        </h1>
        <SearchBox selectItems={searchBoxHeaders} onSubmitSearch={handleSubmitSearch} isSearching={isSearching} onKeyDown={escape} />
      </div>

      <DataTable
        useUid
        head={headers}
        body={transactions}
        bodyColumn={headers}
        action={true}
        linkPath={'transactions'}
        totalPages={totalPages}
        currentPage={actualPage}
        setPageChange={handleChangePage}
        isNotOrdenable
      />
    </>
  );
};

export default WithdrawRequests;
